module.exports = __webpack_public_path__ + "static/media/20anios.16134a1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/relaciones-institucionales-en/20anios.mp4
// module id = +EDv
// module chunks = 0